import { styled } from "@vitality-ds/system";
import BaseMetaLabelStyles from "./styles/BaseMetaLabel.styles";

/* eslint-disable-next-line import/prefer-default-export */
export var BaseMetaLabel = styled("div", BaseMetaLabelStyles);